import React from "react";
import { Theme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { toGermanNumberFormat } from "@helpers";
import { Event } from "@helpers/charts/mergeCloseByDate";
import { Item as ItemOrig } from "./Item";
import { getEventLabel } from "./getEventLabel";

interface Props {
  event: Event;
  theme: Theme;
}

export const EventItem = ({ event, theme }: Props) => {
  const { t } = useTranslation();
  const label = getEventLabel(event, theme.palette);

  return (
    <ItemOrig
      beforeComponent={
        <p
          style={{
            margin: 0,
            paddingRight: "7px",
            paddingLeft: "1px",
            color: label.color,
            fontSize: "24px",
            fontWeight: 500,
            lineHeight: "34px",
            [theme.breakpoints.down("md")]: {
              fontSize: "20px",
              lineHeight: "28px",
            },
          }}
        >
          {label.name}
        </p>
      }
      theme={theme}
      color={label.color}
      title={toGermanNumberFormat(event.amount)}
      subtitle={t(`investmentChartTooltip.${event.type}`)}
    />
  );
};
